import "babel-polyfill";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueCropper from 'vue-cropper';
import ElementUI from 'element-ui';
import vuescroll from 'vuescroll';
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Tips from '@/components/Tips/Dialog'
import EmptyAdd from '@/components/Tips/Empty-add'
import Paging from '@/components/Pagination/Page'
import PageWrapper from '@/components/LayOut/Common/up-down'


// import VueLazyload from 'vue-lazyload';
Vue.use(VueCropper);
Vue.use(ElementUI);
Vue.use(vuescroll);
Vue.use(VueQuillEditor)

/*import loading from "@/assets/images/loading-bubbles.svg";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: loading,
  loading: loading,
  attempt: 1
});*/

import yioks from "@/assets/js/yioks.js";
import {storageData} from "@/assets/js/storage";
import { formateTimeByMomentJs } from "@/assets/js/yioksFilters";
import ops from "@/assets/js/vuescrollOption";

Vue.prototype.$ops = ops();
Vue.prototype.$yioks = yioks;
Vue.prototype.$log = console.log; // 测试日志
Vue.prototype.$warn = console.warn; // 测试日志

// Vue.config.productionTip = false;

/* 全局导航守卫 */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = storageData.getToken();
    if(token) {
      const userInfo = storageData.getUserInfo();
      // setting 页面不需要根据用户角色来判断
      if(/^\/setting/.test(to.fullPath)) {
        next();
        return;
      }
      // 数据屏开发模式下暂时全部开发
      if(/^\/display/.test(to.fullPath)) {
        next();
        return;
      }
      if(/^\/permission/.test(to.fullPath)) {
        next();
        return;
      }
      if(/^\/notice/.test(to.fullPath)) {
        next();
        return;
      }
      /* 问卷调查页面 */
      if(/^\/survey/.test(to.fullPath)) {
        next();
        return;
      }
      /* 球探模块 */
      if(/^\/scout/.test(to.fullPath)) {
        next();
        return
      }
      /* 根据用户权限跳转路径 */
      switch (userInfo.member_type) {
        case "super":
        case "supFive":
        case "system":
        case "sysFive":
          /^\/system/.test(to.fullPath) ? next() : next("/system/sm");
          break;
        case "organ":
        case "orgFive":
          /^\/organization/.test(to.fullPath) ? next() : next("/organization/training_course_manager");
          break;
        case "teacher":
        case "teaFive":
          /^\/teacher/.test(to.fullPath) ? next() : next("/teacher/class");
          break;
        case "student":
        case "stuFive":
          /^\/student/.test(to.fullPath) ? next() : next("/student/student_index");
          break;
        case "registration":
        case "registrationFive":
          /^\/registration/.test(to.fullPath) ? next() : next("/registrationList");
          break;
        case "expireStudent":
        case "expFive":
          /^\/expireStudent/.test(to.fullPath) ? next() : next("/expireStudent/expire_index");
          break;
      }
    }else{
      next({path:"/login"});
    }
  } else {
    next(); // 确保一定要调用 next()
  }
});

Vue.component('y-tips', Tips);
Vue.component('y-tips-action', EmptyAdd);
Vue.component('y-paging', Paging);
Vue.component('y-wrapper', PageWrapper);

/* 全局过<日期时间>过滤器 */
Vue.filter('time', yioks.time);
Vue.filter('timeFormat', formateTimeByMomentJs);

window.yioks_vm = new Vue({
  router,
  store,
  token:'',
  isLogin:false,
  render: h => h(App)
}).$mount('#app');
